import { Instance } from 'mobx-state-tree';
import { CommandHandlerResponseDtoModelBase } from './CommandHandlerResponseDtoModel.base';

/* The TypeScript type of an instance of CommandHandlerResponseDtoModel */
export interface CommandHandlerResponseDtoModelType extends Instance<typeof CommandHandlerResponseDtoModel.Type> {}

/* A graphql query fragment builders for CommandHandlerResponseDtoModel */
export { selectFromCommandHandlerResponseDto, commandHandlerResponseDtoModelPrimitives, CommandHandlerResponseDtoModelSelector } from './CommandHandlerResponseDtoModel.base';

/**
 * CommandHandlerResponseDtoModel
 */
export const CommandHandlerResponseDtoModel = CommandHandlerResponseDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
